'use strict';

angular.module('shop').config(function ($stateProvider) {

	$stateProvider
		.state({
			name: 'shop',
			templateUrl: 'shop.html',
			controller: 'ShopController'
		})
		.state({
			name: 'products',
			parent: 'shop',
			url: '/?category',
			templateUrl: 'products.html',
			controller: 'ProductsController'
		})
		.state({
			name: 'simple-checkout',
			parent: 'shop',
			url: '/simple-checkout/',
			templateUrl: 'simple-checkout.html',
			controller: 'SimpleCheckoutController',
		})
		.state({
			name: 'checkout',
			parent: 'shop',
			url: '/checkout/',
			templateUrl: 'checkout.html',
			controller: 'CheckoutController',
		})
		.state({
			parent: 'shop',
			name: 'account',
			url: '/checkout/account/',
			templateUrl: 'account.html',
			controller: 'AccountController',
			onEnter: function ($state, $timeout, $cookies) {
				if ($cookies.get('cart-token')) {
					$timeout(function() {
						$state.go('delivery-information');
					}, 100);
				}
			}
		})
		.state({
			parent: 'shop',
			name: 'delivery-information',
			url: '/checkout/delivery-information/',
			templateUrl: 'delivery-information.html',
			controller: 'DeliveryInformationController',
			params: {
				back: null
			}
		})
		.state({
			parent: 'shop',
			name: 'duplicate',
			url: '/checkout/duplicate/',
			templateUrl: 'duplicate.html',
			controller: 'DuplicateController'
		})
		.state({
			parent: 'shop',
			name: 'payment',
			url: '/checkout/payment/?order_id',
			templateUrl: 'payment.html',
			controller: 'PaymentController',
			params: {
				back: null
			}
		})
		.state({
			parent: 'shop',
			name: 'confirmation',
			url: '/checkout/confirmation/?order_id',
			templateUrl: 'confirmation.html',
			controller: 'ConfirmationController'
		});
});
